import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/privacy";
import deltas from "../../actions/deltas";

const {SET_PRIVACY_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.STATIC, SET_PRIVACY_STATE);
